import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
export const StringMapContext = createContext({});
export const StringMapProvider = ({ children, value }) => (_jsx(StringMapContext.Provider, { value: value, children: children }));
